import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-761e7df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("lukso-icon", {
  name: "arrow-left-lg",
  color: "neutral-15",
  class: "transition group-hover:-translate-x-1"
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "pl-2" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "qr-image" }
const _hoisted_6 = {
  key: 0,
  class: "qr-code-wrapper mt-4"
}
const _hoisted_7 = { class: "copy mt-6" }
const _hoisted_8 = { class: "copy-text" }

import { Permissions } from '@erc725/erc725.js/build/main/src/types/Method'
import LSP6Schema from '@erc725/erc725.js/schemas/LSP6KeyManager.json'
import { ERC725YDataKeys } from '@lukso/lsp-smart-contracts'
import Client, { SignClient } from '@walletconnect/sign-client'
import { SessionTypes } from '@walletconnect/types'
import assert from 'assert'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import QRCodeShow from '@/popup/components/shared/QRCode/QRCodeShow.vue'
import Spinner from '@/popup/components/shared/Spinner.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import useErc725 from '@/popup/compositions/useErc725'
import { useNotifications } from '@/popup/compositions/useNotifications'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import Notification from '@/popup/components/shared/Notification.vue'
import { useAppStore } from '@/popup/store/AppStore'
import { SMART_CONTRACT_CONFIG } from '@/shared/SmartContractConfig'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'

type Emits = {
  (event: 'import-cancel'): void
}

interface SignResponse {
  controllerAddress: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCode',
  emits: ["import-cancel"],
  setup(__props, { emit: __emit }) {

const defaultControllerPermissions: Permissions = {
  ADDCONTROLLER: true,
  EDITPERMISSIONS: true,
  SUPER_TRANSFERVALUE: true,
  SUPER_CALL: true,
  SUPER_STATICCALL: true,
  DEPLOY: true,
  SUPER_SETDATA: true,
  ENCRYPT: true,
  DECRYPT: true,
  SIGN: true,
  CALL: true,
  STATICCALL: true,
  SETDATA: true,
  TRANSFERVALUE: true,
  EXECUTE_RELAY_CALL: true,
}

function assertSignResponse(
  response: unknown
): asserts response is SignResponse {
  assert(response && typeof response === 'object', 'response is not an object')

  const typedResponse = response as Record<string, unknown>
  assert(
    'controllerAddress' in typedResponse &&
      typeof typedResponse.controllerAddress === 'string',
    'controllerAddress is not a string'
  )
}

const emits = __emit

const onCancel = async () => {
  emits('import-cancel')
}

const appStore = useAppStore()
const { getErc725 } = useErc725()
const { createContract, getWeb3Eth } = useWeb3Eth()
const notifications = useNotifications()
const { t } = useI18n({ useScope: 'global' })
const router = useRouter()

const signClient = ref<Client>()
const session = ref<SessionTypes.Struct>()

// TODO: Re-enable when we handle logic with the Provider Subdomain
// const providerStore = useProviderStore()
// const loadingControllerPermissions = ref(false)
// watch(
//   () => providerStore.currentEvent,
//   event => {
//     switch (event?.type) {
//       case 'RemoteProviderConnectionEstablishedEvent': {
//         loadingControllerPermissions.value = true
//         providerStore.processConnectionEvent(event.id)
//         break
//       }
//       case 'RemoteProviderConnectionClosedEvent': {
//         providerStore.processConnectionEvent(event.id)
//         router.push({ name: 'home' })
//         break
//       }
//       case 'RemoteProviderConnectionExpirationEvent': {
//         qrCodeUrl.value = generateQrCodeUrl()
//         providerStore.processConnectionEvent(event.id)
//         break
//       }
//     }
//   },
//   { immediate: true }
// )
const qrCodeUrl = ref<string>()

const addController = async (controllerAddress: string) => {
  if (!session.value || !signClient.value) {
    console.error('No session or sign client')
    return
  }

  if (!appStore.upExtensionControllerAddress) {
    signClient.value.emit({
      topic: session.value.topic,
      event: {
        name: 'up_import_error',
        data: {
          address: appStore.currentProfile.address,
          error: 'No controller address found',
        },
      },

      chainId: `eip155:${appStore.network.chainId}`,
    })
    return
  }

  const lsp6 = getErc725(appStore.currentProfile.address, LSP6Schema)

  const addressPermissionsKey = ERC725YDataKeys.LSP6['AddressPermissions[]']

  const currentArrayLengthResult = await lsp6.getData(
    addressPermissionsKey.length
  )
  const currentArrayContent = currentArrayLengthResult.value
  assert(
    Array.isArray(currentArrayContent),
    'Expected current array content to be an arry'
  )

  const currentArrayLength = currentArrayContent.length

  const data = lsp6.encodeData([
    {
      keyName: 'AddressPermissions[]',
      value: [controllerAddress],
      totalArrayLength: currentArrayLength + 1,
      startingIndex: currentArrayLength,
    },
    {
      keyName: 'AddressPermissions:Permissions:<address>',
      dynamicKeyParts: controllerAddress,
      value: lsp6.encodePermissions(defaultControllerPermissions),
    },
  ])

  const payload = createContract(SMART_CONTRACT_CONFIG.abis.SET_DATA)
    .methods.setDataBatch(data.keys, data.values)
    .encodeABI()

  const emitEvent = (name: string, payload: any) => {
    signClient.value!.emit({
      topic: session.value!.topic,
      event: {
        name,
        data: payload,
      },
      chainId: `eip155:${appStore.network.chainId}`,
    })
  }

  emitEvent('up_import_start', {
    address: appStore.currentProfile.address,
  })

  getWeb3Eth()
    .sendTransaction({
      from: appStore.currentProfile.address,
      to: appStore.currentProfile.address,
      data: payload,
    })
    .on('error', error => {
      const message = error?.message ?? t('app_detail.save_error')
      notifications.updateToast({
        id: appStore.currentProfile.address,
        message,
        profileAddress: appStore.currentProfile.address,
        method: DBNotifications.NOTIFICATION,
        system: false,
        type: ToastType.ERROR,
        isPersistent: false,
      })

      emitEvent('up_import_error', {
        address: appStore.currentProfile.address,
        error: message,
      })
    })
    .on('sending', () => {
      emitEvent('up_import_execution', {
        address: appStore.currentProfile.address,
      })
    })
    .on('confirmation', (confirmationNumber: number) => {
      console.log('confirmationNumber', confirmationNumber)
      if (confirmationNumber === 1) {
        console.log('Sending import success event')
        emitEvent('up_import_success', {
          address: appStore.currentProfile.address,
        })
      }
    })
}

const requestUpImport = async (
  signClient: Client,
  session: SessionTypes.Struct,
  chainId: number
) => {
  const response = await signClient.request({
    topic: session.topic,
    chainId: `eip155:${chainId}`,
    request: {
      method: 'up_import',
      params: {
        address: appStore.currentProfile.address,
      },
    },
  })
  assertSignResponse(response)
  await addController(response.controllerAddress)
}

const connect = async (signClient: Client, chainId: number) => {
  return await signClient.connect({
    requiredNamespaces: {
      eip155: {
        methods: ['up_import'],
        chains: [`eip155:${chainId}`],
        events: [
          'up_import_start',
          'up_import_success',
          'up_import_execution',
          'up_import_error',
        ],
      },
    },
  })
}

const handleConnection = async () => {
  if (signClient.value) {
    const chainId = appStore.network.chainId

    const { uri, approval } = await connect(signClient.value, chainId)
    qrCodeUrl.value = uri
    const newSession = await approval()
    session.value = newSession
    await requestUpImport(signClient.value, newSession, chainId)
  }
}

const handleExpiry = () => {
  if (signClient.value) {
    signClient.value.on('session_delete', () => {
      router.push('/home')
    })

    signClient.value.on('session_expire', async () => {
      await handleConnection()
      notifications.updateToast({
        id: appStore.currentProfile.address,
        message: t('qr_code.reconnecting'),
        profileAddress: appStore.currentProfile.address,
        method: DBNotifications.NOTIFICATION,
        system: false,
        type: ToastType.ERROR,
        isPersistent: false,
      })
    })
  }
}

onMounted(async () => {
  signClient.value = await SignClient.init({
    projectId: '0d2f194956a2c7c98a88fa5dc3bf1849',
    metadata: {
      name: 'LUKSO',
      description: 'LUKSO Wallet',
      url: 'https://lukso.network',
      icons: ['https://lukso.network/favicon.ico'],
    },
  })
  await handleConnection()
  handleExpiry()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: onCancel,
      class: "profile-qrcode pl-6 pt-6"
    }, [
      _hoisted_2,
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('qr_code.show_qr_code_title')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ProfilePicture, {
          size: "small",
          "frontend-profile": _unref(appStore).currentProfile,
          class: "profile-pix"
        }, null, 8 /* PROPS */, ["frontend-profile"]),
        (!qrCodeUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(Spinner, { "data-testid": "spinner" })
            ]))
          : (_openBlock(), _createBlock(QRCodeShow, {
              key: 1,
              value: qrCodeUrl.value,
              size: 242,
              "data-testid": "qrcode=show",
              class: "fade-in mt-4"
            }, null, 8 /* PROPS */, ["value"]))
      ]),
      _createVNode(UserName, {
        profile: _unref(appStore).currentProfile,
        "max-width": 210,
        "has-at-sign": true,
        "has-slice-address": true,
        "name-class": "gradient-text",
        class: "mt-6"
      }, null, 8 /* PROPS */, ["profile"]),
      _createVNode(ClipboardCopy, {
        value: qrCodeUrl.value,
        "has-hover-text": false,
        "offset-distance": "7",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(SvgIcon, {
              name: "copy",
              class: ""
            }),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('clipboard_copy.hover_text')), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"]),
      (qrCodeUrl.value)
        ? (_openBlock(), _createBlock(Notification, {
            key: 0,
            type: "warning",
            class: "do-not-close slide-in mt-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('qr_code.do_not_close')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})